import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import * as backInter from 'app/auth/auth-data.model';
import { DATOS_API } from 'app/auth/auth.datos';
/// SERVICIO DE AUTENTICACION
import { AuthService } from 'app/auth/auth.service';

import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ConteosService {

  idEmpresa: string;
  idUsuario: string;

  constructor(
    private http:HttpClient,
    private authService:AuthService
  ) {
    if(this.authService.getIsAuth()){
      this.obtienInfo();
    }
  }

  obtienInfo()
  {
    this.idUsuario = this.authService.getIdUsuario();
    let infoUsu: backInter.infoUsuario = this.authService.getInfoUsuario();
    this.idEmpresa = infoUsu.empresaId;
  }

   getListaFiltros(datos){
    // console.log("entro el servioczfd");
    // console.log(datos);
    // let datos:any = {user: "prro"};
    console.log(DATOS_API.url + DATOS_API.endpoints.getFiltrosConteo);
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.getFiltrosConteo, datos);//id plantilla fecha certif
  }

   getConteoFiltro(datos: any){
     this.obtienInfo();
    console.log(datos);
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.getConteosFiltros+this.idEmpresa, datos);
    }

  getConteoFiltroNuevaVersion(datos: any){
   console.log(datos);
   return this.http.get(DATOS_API.url + DATOS_API.endpoints.getConteosFiltrosNuevaVersion+datos);
  }

 getConteoExcelVersionReducida(datos: any){
  console.log(datos);
  return this.http.get(DATOS_API.url + DATOS_API.endpoints.getConteosExcelVersionReducida+datos);
}

 getConteoExternoFiltroNuevaVersion(productoId:any, idEmpresa:any){
   let token='$2y$05$VN3dMRXYzo5UfwAt6MAekO8cuJ3uHcbWqZXyUWIv3g.oTdyaDnGCO';
   let parametro=1;
  console.log(productoId);
  return this.http.get(DATOS_API.url + DATOS_API.endpoints.getConteosFiltrosNuevaVersionExterna+idEmpresa+'/'+productoId+'/'+token+'/'+parametro);
}

getConteoExternoFiltroNuevaVersionReducido(productoId:any, idEmpresa:any){
  let token='$2y$05$VN3dMRXYzo5UfwAt6MAekO8cuJ3uHcbWqZXyUWIv3g.oTdyaDnGCO';
  let parametro=2;
 console.log(productoId);
 return this.http.get(DATOS_API.url + DATOS_API.endpoints.getConteosFiltrosNuevaVersionExterna+idEmpresa+'/'+productoId+'/'+token+'/'+parametro);
}
   getConteoFiltroPortalCer(datos: any, idempresa: any){

    console.log(datos);
return this.http.post(DATOS_API.url + DATOS_API.endpoints.getConteosFiltros+idempresa, datos);
  }

   getConteoFiltroMedir(datos: any){
     this.obtienInfo();
    console.log(datos);
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.getConteosFiltrosMedir+this.idEmpresa, datos);
  }
   getConteoFiltroPortalMedir(datos: any,idempresa: any){
    console.log(datos);
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.getConteosFiltrosMedir+idempresa, datos);
  }

   getConteoFiltroPulse(data: any){
     this.obtienInfo();
    console.log(data);
    console.log(this.idEmpresa);
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.getConteosFiltrosPulse+this.idEmpresa, data);
  }
   getConteoFiltroPortalPulse(data: any,idempresa: any){
    this.obtienInfo();console.log(data);
    console.log(this.idEmpresa);
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.getConteosFiltrosPulse+idempresa, data);
  }
   getConteoFiltroFocusArea(data: any){
    console.log(data);
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.getConteosFiltrosFocusArea+localStorage.getItem('encuestaID'), data);
  }

   getConteoFiltroPortalFocusArea(data: any,idempresa: any){
    console.log(data);
    console.log(this.idEmpresa);
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.getConteosFiltrosFocusArea+idempresa, data);
  }

   getTimeLineGraficaCertificar(){
     console.log("Service getTimeLineGraficaCertificar ");
     console.log(this.idEmpresa);
     this.obtienInfo();
     console.log(localStorage.getItem('Surveystaus_portal'));
    if(this.idEmpresa == '0' && localStorage.getItem('Surveystaus_portal')== "activo"){
      this.idEmpresa=localStorage.getItem('idEmpresa_surveysatus');
      console.log("entro get time line certificar");
      console.log(localStorage.getItem('productoID'));
    }
     console.log(DATOS_API.url + DATOS_API.endpoints.getGraficaCertificar+this.idEmpresa+"/"+localStorage.getItem('productoID'));
     return this.http.get(DATOS_API.url + DATOS_API.endpoints.getGraficaCertificar+this.idEmpresa+"/"+localStorage.getItem('productoID'));
  }

   getTimeLineGraficaCertificarForaneo(idempresa:string ,idproducto:string){
     // console.log(DATOS_API.url + DATOS_API.endpoints.getGraficaCertificar+this.idEmpresa+"/"+localStorage.getItem('productoID'));
     return this.http.get(DATOS_API.url + DATOS_API.endpoints.getGraficaCertificar+idempresa+"/"+idproducto);
  }

   getTimeLineGraficaMedir(){
     this.obtienInfo();
     console.log(DATOS_API.url + DATOS_API.endpoints.getGraficaMedir+this.idEmpresa+"/"+localStorage.getItem('productoID'));
     return this.http.get(DATOS_API.url + DATOS_API.endpoints.getGraficaMedir+this.idEmpresa+"/"+localStorage.getItem('productoID'));
  }
  getTimeLineGraficaMedirForaneo(idempresa:string ,idproducto:string){
    // console.log(DATOS_API.url + DATOS_API.endpoints.getGraficaCertificar+this.idEmpresa+"/"+localStorage.getItem('productoID'));
    return this.http.get(DATOS_API.url + DATOS_API.endpoints.getGraficaMedir+idempresa+"/"+idproducto);
 }
   getTimeLineGraficaPulse(){
     // console.log(DATOS_API.url + DATOS_API.endpoints.getGraficaMedir+this.idEmpresa+"/"+localStorage.getItem('productoID'));
     if(this.idEmpresa == '0' && localStorage.getItem('Surveystaus_portal')== "activo"){
      this.idEmpresa=localStorage.getItem('idEmpresa_surveysatus');
    }
     return this.http.get(DATOS_API.url + DATOS_API.endpoints.getGraficaPulse+this.idEmpresa+"/"+localStorage.getItem('productoID'));
  }
  getTimeLineGraficaPulseForaneo(idempresa:string ,idproducto:string){
    // console.log(DATOS_API.url + DATOS_API.endpoints.getGraficaCertificar+this.idEmpresa+"/"+localStorage.getItem('productoID'));
    return this.http.get(DATOS_API.url + DATOS_API.endpoints.getGraficaPulse+idempresa+"/"+idproducto);
 }

  getTimeLineGraficaNorma35(datos,bandera?){
     console.log(datos);
     this.obtienInfo();
     console.log(DATOS_API.url + DATOS_API.endpoints.getGraficaNorma35+this.idEmpresa+"/"+localStorage.getItem('productoID')+"/"+localStorage.getItem('surveytype'));

     if(bandera){
      console.log("Desde status encuesta");
      let idEmpresa= localStorage.getItem('idEmpresa_surveysatus');
      return this.http.get(DATOS_API.url + DATOS_API.endpoints.getGraficaNorma35+idEmpresa+"/"+localStorage.getItem('productoID')+"/"+localStorage.getItem('surveytype'));
    }else{
      return this.http.get(DATOS_API.url + DATOS_API.endpoints.getGraficaNorma35+this.idEmpresa+"/"+localStorage.getItem('productoID')+"/"+localStorage.getItem('surveytype'));
    }
  }

  getTimeLineGraficaNorma35Foraneo(idempresa:string ,idproducto:string){
    // console.log(DATOS_API.url + DATOS_API.endpoints.getGraficaCertificar+this.idEmpresa+"/"+localStorage.getItem('productoID'));
    return this.http.get(DATOS_API.url + DATOS_API.endpoints.getGraficaNorma35+idempresa+"/"+idproducto);
 }

  getTimeLineGraficaFocusArea(){
    this.obtienInfo();
   return this.http.get(DATOS_API.url + DATOS_API.endpoints.getGraficaFocusArea+this.idEmpresa+"/"+localStorage.getItem('encuestaID'));
  }

  getTimeLineGraficaFocusAreaForaneo(idempresa:string ,idproducto:string){
    // console.log(DATOS_API.url + DATOS_API.endpoints.getGraficaCertificar+this.idEmpresa+"/"+localStorage.getItem('productoID'));
    return this.http.get(DATOS_API.url + DATOS_API.endpoints.getGraficaFocusArea+idempresa+"/"+idproducto);
 }










  getInfoDescargaExcelCertificar(datos){
    this.obtienInfo();
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.getDescargaExcelCertificar+this.idEmpresa,datos);
 }
  getInfoDescargaExcelCertificarForaneo(datos,idempresa:string){
    console.log(idempresa);

    return this.http.post(DATOS_API.url + DATOS_API.endpoints.getDescargaExcelCertificar+idempresa,datos);
 }
  getInfoDescargaExcelMedir(datos){
    this.obtienInfo();
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.getDescargaExcelMedir+this.idEmpresa,datos);
 }
  getInfoDescargaExcelMedirForaneo(datos,idempresa:string){
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.getDescargaExcelMedir+idempresa,datos);
 }
  getInfoDescargaExcePulse(datos){
    this.obtienInfo();
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.getDescargaExcelPulse+this.idEmpresa,datos);
 }
  getInfoDescargaExcelPulseForaneo(datos,idempresa:string){
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.getDescargaExcelPulse+idempresa,datos);
 }
  getInfoDescargaExceFocusArea(datos){
    this.obtienInfo();
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.getDescargaExcelFocus+this.idEmpresa,datos);
 }

 //  getInfoDescargaExcelPulseFocusArea(datos,idempresa:string){
 //    return this.http.post(DATOS_API.url + DATOS_API.endpoints.getDescargaExcelPulse+idempresa,datos);
 // }

 getInfoEmpresa(){
  this.obtienInfo();
  console.log("info empresa "+this.idEmpresa);
  console.log(localStorage.getItem('Surveystaus_portal'));
  if(this.idEmpresa == '0' && localStorage.getItem('Surveystaus_portal')== "activo"){
    console.log("Entro nueva condición");
    console.log(localStorage.getItem('idEmpresa_surveysatus'));
    this.idEmpresa=localStorage.getItem('idEmpresa_surveysatus');
    console.log(this.idEmpresa);
  }
  return this.http.get(DATOS_API.url + DATOS_API.endpoints.empresas + this.idEmpresa);
}


getProrrogasFechaCierre(datos:any){
  return this.http.get(DATOS_API.url + DATOS_API.endpoints.fechaCierre.getProrrogasFechaEncuesta + datos);
}

}
